import { Row, Table, ValueCell } from '@/wpt-lib/pdf/common/Table';
import * as React from 'react';
import { WorkplanVersion } from '@/wpt-lib/interfaces/Workplan';
import SubHeading from '@/wpt-lib/pdf/common/SubHeading';
import { isNullish } from '@/wpt-lib/utils/isNullish';
import useData from '@/wpt-lib/pdf/useData';
import { conflictOfInterestText } from '@/wpt-lib/text/conflictOfInterest';

const Declarations = ({
    plannedLeaveDeclaration,
    conflictOfInterestDeclaration,
}: Pick<WorkplanVersion, 'plannedLeaveDeclaration' | 'conflictOfInterestDeclaration'>) => {
    const { workplan } = useData();

    return (
        <Table cols={1}>
            <Row>
                <SubHeading level={2} text="Declarations" />
            </Row>
            <Row>
                <ValueCell
                    label="Planned Leave"
                    value={
                        plannedLeaveDeclaration
                            ? 'I have discussed my leave plans with my supervisor for this workplanning year.'
                            : 'I have not discussed my leave plans with my supervisor for this workplanning year.'
                    }
                />
            </Row>
            {!isNullish(conflictOfInterestDeclaration) && (
                <Row>
                    <ValueCell
                        label={'Conflict of Interest Declaration'}
                        value={conflictOfInterestText(workplan.year)[conflictOfInterestDeclaration ? 1 : 0]}
                    />
                </Row>
            )}
        </Table>
    );
};

export default Declarations;
